module.exports = __webpack_public_path__ + "static/media/390x310-Santiago.8a57156b.jpg";